import React from 'react';
import { Form } from 'react-final-form';
import { FormApi } from 'final-form';

import { InfoDialog, getStateSingleAutocompleteInitialValues } from '@occc-app/design-system';
import { LocationFragment, MembershipFragment } from '@occc/graphql';
import { parseDate } from '@occc-app/lib/date';

import EditModalForm, { EditModalFormFields } from './EditModalForm';
import { validateMemberUpdate } from './validation';

export interface IEditModalProps {
  member: MembershipFragment;
  locations?: LocationFragment[];
  show: boolean;
  onHide: () => void;
  onSubmit: (inputs: EditModalFormFields, form: FormApi<EditModalFormFields>) => void;
}

const EditModal: React.FC<IEditModalProps> = ({ member, locations, show, onHide, onSubmit }) => {
  const { birthdate, email, firstName, lastName, phone, primaryAddress } = member;

  const initialValues: Partial<EditModalFormFields> = React.useMemo(() => {
    return {
      birthdate: birthdate ? parseDate(birthdate) : null,
      email,
      firstName,
      lastName,
      phone: phone || undefined,
      homeStores: locations,
      primaryAddress: {
        address1: primaryAddress?.address1,
        address2: primaryAddress?.address2,
        city: primaryAddress?.city,
        state: primaryAddress?.state
          ? getStateSingleAutocompleteInitialValues(primaryAddress.state)
          : undefined,
        zipcode: primaryAddress?.zipcode,
      },
    };
  }, [birthdate, email, firstName, lastName, phone, locations, primaryAddress]);

  return (
    <InfoDialog dialogTitle='Update Member Information' onClose={onHide} open={show} maxWidth='xs'>
      <Form<EditModalFormFields>
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={validateMemberUpdate}
        render={(props) => <EditModalForm {...props} onHide={onHide} />}
      />
    </InfoDialog>
  );
};

export default EditModal;
